import { CheckoutPage } from '@/features/setting/page/checkout-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/workspace/$workspaceId/checkout')({
  component: CheckoutPage,
});
